export enum ORDER {
  desc = -1,
  asc = 1
}



// WEBPACK FOOTER //
// /dist/src/app/shared/grid/order.enum.ts